import {Status} from 'commonTypes'
import {PaginationState, SortingState} from '@tanstack/react-table'
import {DiagnosticType} from 'api/graphQL/generated/graphql'

export type URLOption = {
  label: string
  value: string
  subLabel: string
  databaseId?: string
  hostname?: string
}

const defaultDiagnosticsState = {
  gridSession: {
    pageSizeOptions: [10, 25, 50],
    pagination: {
      pageIndex: 0,
      pageSize: 10,
    } as PaginationState,
    sorting: [] as SortingState,
    columnOrder: [] as string[],
    filters: {
      searchQuery: '',
    },
  },
  diagnosticScriptOptions: [] as { label: string; value: string }[],
  urlOptions: [] as URLOption[],
  selectedUrl: null as string | null,
  selectedScript: null as DiagnosticType | null,
  status: Status.IDLE,
  error: null as any,
  diagnosticResults: [] as any[],
  columnsConfig: [] as { accessorKey: string; header: string }[],
  totalCount: 0,
  shouldRunDiagnostic: false,
  diagnosticDetailsItem: null as any,
  showDetailsPanel: false,
}

export type GridSessionType = typeof defaultDiagnosticsState.gridSession

export type DiagnosticsStateType = typeof defaultDiagnosticsState

export default defaultDiagnosticsState
